import { chain } from '@leprecoins/effector';
import { createEffect, createEvent } from 'effector';
import { resultModel } from 'pages/result-page';
import { interactiveElementModel } from 'widgets/interactive-element';
import { socket } from 'shared/api';
import { VITE_ASSETS_VARIANT } from 'shared/config';
import {
	agent,
	breakpoints,
	fullscreen,
	language,
	musicMaster,
	orientation,
	soundsMaster,
} from 'shared/lib';

export const appStarted = createEvent();

export const setTitleFx = createEffect(() => {
	const name = VITE_ASSETS_VARIANT;
	document.title = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
});

chain(appStarted, setTitleFx);

chain(appStarted, breakpoints.setup);

chain(appStarted, interactiveElementModel.setup);

chain(appStarted, socket.connect);

chain(appStarted, fullscreen.setup);

chain(appStarted, agent.setup);

chain(appStarted, orientation.setup);

chain(appStarted, soundsMaster.setup);

chain(appStarted, musicMaster.setup);

chain(appStarted, language.setup);

chain(appStarted, resultModel.setup);
